import { render, staticRenderFns } from "./ChoosePlanet.vue?vue&type=template&id=6d14e37c&scoped=true"
import script from "./ChoosePlanet.vue?vue&type=script&lang=js"
export * from "./ChoosePlanet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d14e37c",
  null
  
)

export default component.exports